import messagesEn from "./messages.en"
import messagesSk from "./messages.sk"

export const messages = {
  en: messagesEn,
  sk: messagesSk
}
export { I18n } from "./i18n"
